import { actions } from 'react-redux-form';
import { httpPost, httpGet } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { EQUIPMENT_TYPE as EquipmentType } from '../../../../../utils/constant.utils';
import { getAddresses, getUserLocation } from '../../order-request.functions';
import { CIRCUIT_TYPES as CircuitTypes } from '../../../../../utils/constant.utils';
import {
    //model
    wirelessReplaceDeviceModel
    //action
    , setUserLocation
    , setAddressOptions
    , setBusinessCaseOptions
    , setCountryOptions
    , setEquipmentOptions
    //, setDeviceOptions
    , setDeviceAccessories
    , setFormSubmitted
    , setSubscriptionDetails
    , setServiceTypeDetails
    , setFormLoading
    , setResetLoading

    , setMobServiceTypeLoading
    , setAddressLoading
    , setCountryLoading
} from './../../../../../constants/model-reducers/external/request/wireless-request/wireless-replace-device.settings';

export const replaceDeviceModelAInitialState = wirelessReplaceDeviceModel;


const serviceTypeDetailConst = {
    EquipmentInventoryId: 0
    , OrderCost: 0
}

const defaultState = () => ({
    subscription: {}
    , userLocation: {}
    , countryOptions: []
    , addressOptions: []
    , equipmentOptions: []
    , businessCaseOptions: []
    //, deviceOptions: []
    , deviceAccessories: []
    , serviceTypeDetail: { ...serviceTypeDetailConst }
    , formSubmitted: false
    , isResetLoading: false

    , mobServiceTypePage: 1
    , hasMoreMobServiceType: true
    , isMobServiceTypeLoading: false

    , countryPage: 1
    , hasMoreCountry: true
    , isCountryLoading: false

    , addressPage: 1
    , hasMoreAddress: true
    , isAddressLoading: false

});

const initialState = defaultState();

export const wirelessReplaceDeviceActions = {

    getReplaceDeviceFormData: () => (dispatch, state) => {
        const { requestTypeId } = state().createRequest;        
        getUserLocation(dispatch, setUserLocation, requestTypeId);
        getCountries(dispatch);
        getBusinessCases(dispatch);        
    }
    , updateSubscriptionDetails: (subscriptionList, circuitCodePropName) => async (dispatch, state) => {
        const { requestData, isAmending } = state().requestDetail;
        const { wirelessReplaceDeviceFormA } = state().form;
        const pageIndex = 1;
        const pageSize = 15;

        var userData = getUserData();
        if (requestData.Order.IsRequestedInBehalf) {
            userData.employeeID = requestData.RequestedInBeHalfOf.EmployeeId;
        }

        const countryName = wirelessReplaceDeviceFormA.country ? wirelessReplaceDeviceFormA.country : isAmending ? requestData?.BillingAddress?.CountryName ?? '' : '';
        let isOtherLocation = wirelessReplaceDeviceFormA.billingLocationAddressId !== '' && wirelessReplaceDeviceFormA.billingLocationAddressId !== undefined && wirelessReplaceDeviceFormA.billingLocationAddressId !== 0 ?
            (wirelessReplaceDeviceFormA.billingLocationAddressId === -1 ? true : false) : requestData.BillingAddress.IsOtherLocation;

        const addressValue = isOtherLocation ? 'Other' : requestData.BillingAddress.DeliveryAddress;

        await getCountries(dispatch, pageIndex, countryName);
        await getAddresses(dispatch, setAddressOptions, requestData.BillingAddress.CountryCode, isOtherLocation, pageIndex, addressValue, setAddressLoading);
        await getMobileServiceTypeOptions(dispatch, requestData.Subscription.VendorDetailId, requestData.Subscription.CircuitTypeId, userData.employeeID, pageIndex, requestData.Subscription.Device?.EquipmentModel);
        let url = 'external/autosuggest/getAllDeviceSubscriptionSuggestions/';

        var res = await httpGet(url
            + userData.employeeID + '/'
            + requestData.Order.RequestType.RequestTypeID
            + '?val=' + encodeURIComponent(requestData.Circuit.CircuitCode));

        if (requestData.Circuit.CircuitCode === '') {
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            var obj = res.find(o => o['CircuitCode'] === requestData.Circuit.CircuitCode);
            if (obj != null && obj.CircuitId != wirelessReplaceDeviceFormA.circuitId) {
                dispatch(actions.change("wirelessReplaceDeviceFormA.circuitCode", requestData.Circuit.CircuitCode));
                dispatch(actions.change('wirelessReplaceDeviceFormA.circuitId', requestData.Circuit.CircuitId));
                dispatch({ type: setSubscriptionDetails, data: obj });
                dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
            }
        }        
        dispatch(actions.change('wirelessReplaceDeviceFormA.equipmentInventoryId', requestData.Subscription.EquipmentInventoryId));
        dispatch(actions.change('wirelessReplaceDeviceFormA.additionalInformation', requestData.BusinessJustification.AdditionalInformation));
        dispatch(actions.change('wirelessReplaceDeviceFormA.countryCode', requestData.BillingAddress.CountryCode));
        dispatch(actions.change('wirelessReplaceDeviceFormA.phoneCaseAccessory', requestData.Subscription.PhoneCaseAccessory));

        getServiceTypeDetails(dispatch, requestData.Subscription.EquipmentInventoryId);

        if (requestData.BillingAddress.IsOtherLocation === true) {
            dispatch(actions.change('wirelessReplaceDeviceFormA.otherLocationAddressId', requestData.BillingAddress.OtherDeliveryAddressId));
            dispatch(actions.change('wirelessReplaceDeviceFormA.otherLocationAddress', requestData.BillingAddress.OtherDeliveryAddress));
            dispatch(actions.change('wirelessReplaceDeviceFormA.billingLocationAddressId', requestData.BillingAddress.LocationId));
        }
        else {
            dispatch(actions.change('wirelessReplaceDeviceFormA.billingLocationAddressId', requestData.BillingAddress.LocationId))
        }
        dispatch(actions.change('wirelessReplaceDeviceFormA.deliveryAddress', requestData.BillingAddress.DeliveryAddress))
    }
    ,setLoadForm: (isLoad = false) => (dispatch, state) => {
        dispatch({
            type: setFormLoading,
            data: isLoad
        });
    }
    , setRequestorAddress: () => async (dispatch, state) => {

        const { showOtherAddress, userLocation } = state().wirelessReplaceDeviceRequest;
        const { requestOnBehalfData } = state().createRequest;
        const pageIndex = 1;

        var location = {
            ...userLocation
        };

        if (requestOnBehalfData.EmployeeId > 0) {
            location = {
                ...requestOnBehalfData.LocationModel
            };
        }

        await getAddresses(dispatch, setAddressOptions, location.CountryCode, showOtherAddress, pageIndex, location.DeliveryAddress, setAddressLoading);
        await getCountries(dispatch, pageIndex, location.CountryName)

        dispatch(actions.change('wirelessReplaceDeviceFormA.country', location.CountryName));
        dispatch(actions.change('wirelessReplaceDeviceFormA.countryCode', location.CountryCode));
        dispatch(actions.change('wirelessReplaceDeviceFormA.billingLocationAddressId', location.LocationId));
        dispatch(actions.change('wirelessReplaceDeviceFormA.otherLocationAddress', ''));
        dispatch(actions.change('wirelessReplaceDeviceFormA.deliveryAddress', location.DeliveryAddress));        
    }
    , onCircuitSelect: (value, propsName, objects, index) => (dispatch, state) => {

        const { wirelessReplaceDeviceFormA } = state().form;
        const { isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const pageIndex = 1;

        var userData = getUserData();
        if (isRequestOnBehalf && requestOnBehalfData.EmployeeId > 0) {
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }
        
        dispatch(actions.change('wirelessReplaceDeviceFormA.accessoryDetailsModel', []));
        dispatch(actions.change('wirelessReplaceDeviceFormA.mobileServiceModel', []));
        dispatch(actions.change('wirelessReplaceDeviceFormA.equipmentInventoryId', 0));
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });

        if (value === '' || !propsName) {
            dispatch(actions.reset('wirelessReplaceDeviceFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
            //dispatch({ type: setDeviceOptions, data: defaultState.deviceOptions });
            dispatch({ type: setDeviceAccessories, data: [] });
        } else {
            if(propsName) {
                var obj=null              
                if(objects !== null && objects !== undefined) {
                    if(index !== -1 && index !== undefined && index !== null) {
                        obj=objects[index]
                    }
                    else if(objects.length === 1) {
                        obj=objects.find(o => o[propsName] === value);
                    }
                    else if (objects.length > 1) {
                        obj = objects.find(o => o[propsName] === value);
                    } 
                }
                if (obj != null && obj.CircuitId != wirelessReplaceDeviceFormA.circuitId) {
                    dispatch(actions.reset('wirelessReplaceDeviceFormA'));
                    dispatch(actions.change('wirelessReplaceDeviceFormA.circuitCode', obj.CircuitCode));
                    dispatch(actions.change('wirelessReplaceDeviceFormA.circuitId', obj.CircuitId));
                    dispatch({ type: setSubscriptionDetails, data: obj });
                    getMobileServiceTypeOptions(dispatch, obj.VendorDetailId, obj.CircuitTypeId, userData.employeeID, pageIndex, '', obj.DeviceEquipmentId);
                    dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
                }
            }            
        }
    }
    , onServiceTypeSelect: (model, value) => (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelessReplaceDeviceFormA.mobileServiceModel', []));
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        getServiceTypeDetails(dispatch, value);

    }
    , onAccessorySelect: (e) => async (dispatch, state) => {

        const { deviceAccessories } = state().wirelessReplaceDeviceRequest;
        const { wirelessReplaceDeviceFormA } = state().form;
        var selectedObj = deviceAccessories.find(x => x.EquipmentInventoryId == e.target.value);
        var newAccessories = [...wirelessReplaceDeviceFormA.accessoryDetailsModel];

        if (e.target.checked) {
            newAccessories.push(selectedObj);
        } else {

            const indexOfObject = wirelessReplaceDeviceFormA.accessoryDetailsModel.findIndex(o => {
                return o.EquipmentInventoryId == e.target.value;
            });

            newAccessories.splice(indexOfObject, 1);
        }

        dispatch(actions.change('wirelessReplaceDeviceFormA.accessoryDetailsModel', newAccessories));
    }
    , onCountrySelect: (model, value) => async (dispatch, state) => {
        const { countryOptions } = state().wirelessReplaceDeviceRequest;
        const pageIndex = 1;

        dispatch(actions.change(model, value));

        let country = countryOptions.find(o => o['Key'] === value)?.Value;

        dispatch(actions.change('wirelessReplaceDeviceFormA.country', country));
        dispatch(actions.reset('wirelessReplaceDeviceFormA.billingLocationAddressId', ''));
        dispatch(actions.reset('wirelessReplaceDeviceFormA.otherLocationAddress', ''));
        dispatch(actions.reset('wirelessReplaceDeviceFormA.deliveryAddress', ''));

        getAddresses(dispatch, setAddressOptions, value, false, pageIndex, '', setAddressLoading);

    }
    , onAddressSelect: (model, value) => async (dispatch, state) => {

        const { addressOptions } = state().wirelessReplaceDeviceRequest;

        dispatch(actions.change(model, value));

        const deliveryAddress = addressOptions.length > 0 ? addressOptions.find(r => r.Key == value).Value : '';
        dispatch(actions.change('wirelessReplaceDeviceFormA.deliveryAddress', deliveryAddress));
        dispatch(actions.change('wirelessReplaceDeviceFormA.otherLocationAddress', ''));

    }
    , submitRequest: (isReplaceUpgradeEligible) => async (dispatch, state) => {

        const { wirelessReplaceDeviceFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData, isUpdateRequest } = state().createRequest;
        const { subscription, serviceTypeDetail } = state().wirelessReplaceDeviceRequest;
        const { requestData } = state().requestDetail;
        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.vip = requestOnBehalfData.Vip;
        }

        userData.managerApproverId = isRequestOnBehalf ?
            requestOnBehalfData.CostCodeApproverEmployeeId : sessionStorage.CostCodeAuthorizerID;

        var data = {
            ChangeRequestModel: {
                ...userData
                , ...wirelessReplaceDeviceFormA
                , VendorDetailId: subscription.VendorDetailId
                , RequestTypeId: requestTypeId
                , EquipmentTypeId: wirelessReplaceDeviceFormA.mobileServiceModel[0].EquipmentTypeId
                , FinanceAccountId: wirelessReplaceDeviceFormA.mobileServiceModel[0].FinanceAccountId
                , OrderId: isUpdateRequest ? requestData.Order.OrderId : 0
                , CircuitId: wirelessReplaceDeviceFormA.circuitId
                , AdditionalInformation: wirelessReplaceDeviceFormA.additionalInformation
                , PhoneCaseAccessory: wirelessReplaceDeviceFormA.phoneCaseAccessory
                , RequestTypeId: requestTypeId
                , EquipmentInventoryId: wirelessReplaceDeviceFormA.mobileServiceModel[0].EquipmentInventoryId
                , EquipmentInventory: wirelessReplaceDeviceFormA.mobileServiceModel[0].EquipmentModel
                , otherLocationAddress: wirelessReplaceDeviceFormA.otherLocationAddress
                , OrderInfoId: isUpdateRequest ? requestData.OrderInfoId : 0
                , CircuitOrderId: isUpdateRequest ? requestData.CircuitOrderId : 0
                , CountryCode: wirelessReplaceDeviceFormA.countryCode
                , BillingLocationAddressId: wirelessReplaceDeviceFormA.deliveryAddress[0].LocationId
                , Price: wirelessReplaceDeviceFormA.mobileServiceModel[0].OrderCost
                , ProductName: wirelessReplaceDeviceFormA.mobileServiceModel[0].ProductName
                , IsReplaceUpgradeEligible: isReplaceUpgradeEligible
                , OrderCost: serviceTypeDetail.OrderCost !== undefined || serviceTypeDetail.OrderCost !== null ? serviceTypeDetail.OrderCost : 0.00
            }
            , CountryCode: wirelessReplaceDeviceFormA.countryCode
            , DeliveryAddressID: wirelessReplaceDeviceFormA.billingLocationAddressId
            , NewDeviceTypeId: wirelessReplaceDeviceFormA.equipmentInventoryId
            , IsAmending: isUpdateRequest
        }

        dispatch({ type: setFormSubmitted, data: true });

        var res = await httpPost('external/replaceDevice/submitReplaceDevice', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;

    }
    , resetWirelessReplaceDeviceForm: (isResetRequestOnBehalf = false) => (dispatch, state) => {

        const { takeActionCircuitCode } = state().createRequest;
        if((takeActionCircuitCode !== '' && takeActionCircuitCode !== undefined && takeActionCircuitCode !== null) && isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: false });
            return;
        }
        if (isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: true });
            dispatch(actions.reset('wirelessReplaceDeviceFormA.circuitCode'));
            dispatch(actions.reset('wirelessReplaceDeviceFormA.circuitId'));
            dispatch({ type: setSubscriptionDetails, data: {} });

            setTimeout(function () {
                dispatch({ type: setResetLoading, data: false });
            }, 5);
        }
        else if (!isResetRequestOnBehalf) {
            dispatch(actions.reset('wirelessReplaceDeviceFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        }
        dispatch(actions.reset('wirelessReplaceDeviceFormA'));
        dispatch({ type: setFormSubmitted, data: false });
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        dispatch({ type: setDeviceAccessories, data: [] });
        dispatch({ type: setEquipmentOptions, mobileServiceTypeOptions: [], mobServiceTypePage: 1});
    }

    , checkReplaceUpgradeEligibility: (circuitId) => async (dispatch) => {
        try {
            if(circuitId ){
                const res = await httpPost('external/replaceDevice/checkReplaceUpgradeEligibility/' + circuitId);
                return res;
            }
            else {
                return false;
            }
        } catch (error) {
            return false;
        }
    }
    , handleMobServiceTypeSearch: (searchString) => (dispatch, state) => {
        const { subscription } = state().wirelessReplaceDeviceRequest;
        const pageIndex = 1;
        var userData = getUserData();

        getMobileServiceTypeOptions(dispatch, subscription.VendorDetailId, subscription.CircuitTypeId, userData.employeeID, pageIndex, searchString);
    }
    , loadMoreMobServiceType: (searchString) => (dispatch, state) => {
        const { mobServiceTypePage, subscription } = state().wirelessReplaceDeviceRequest;
        
        const pageIndex = mobServiceTypePage + 1;
        var userData = getUserData();

        getMobileServiceTypeOptions(dispatch, subscription.VendorDetailId, subscription.CircuitTypeId, userData.employeeID, pageIndex, searchString);
    }
    , handleAddressSearch: (searchString) => (dispatch, state) => {
        const { showOtherAddress } = state().wirelessReplaceDeviceRequest;
        const { wirelessReplaceDeviceFormA } = state().form;
        const pageIndex = 1;

        getAddresses(dispatch, setAddressOptions, wirelessReplaceDeviceFormA.countryCode, showOtherAddress, pageIndex, searchString, setAddressLoading);
    }
    , loadMoreAddress: (searchString) => (dispatch, state) => {
        const { addressPage, showOtherAddress } = state().wirelessReplaceDeviceRequest;
        const { wirelessReplaceDeviceFormA } = state().form;
        const pageIndex = addressPage + 1;

        getAddresses(dispatch, setAddressOptions, wirelessReplaceDeviceFormA.countryCode, showOtherAddress, pageIndex, searchString, setAddressLoading);
    }
    , handleCountrySearch: (query) => (dispatch, state) => {
        getCountries(dispatch, 1, query);
    }
    , loadMoreCountry: (searchString) => (dispatch, state) => {
        const { countryPage } = state().wirelessReplaceDeviceRequest;

        getCountries(dispatch, countryPage + 1, searchString);
    }
}

async function getDeviceAccessories(dispatch, vendorId) {

    var res = await httpGet('external/orderRequest/getEquipmentData/' + vendorId + '/' + EquipmentType.Accessory);

    if (res != null && res.length > 0) {
        dispatch({ type: setDeviceAccessories, data: res });
    } else {
        dispatch({ type: setDeviceAccessories, data: [] });
    }
}

async function getCountries(dispatch, page = 1, searchString = '') {
    const pageSize = 15;
    dispatch({
        type: setCountryLoading,
        payload: true
    });
    let url = `external/orderRequest/getCountryList/${page}/${pageSize}`
    if (searchString) {
        url += `/${encodeURIComponent(searchString)}`;
    }
    var res = await httpGet(url)

    try {
        if (res != null) {
            dispatch({
                type: setCountryOptions,
                payload: {
                    country: res,
                    countryPage: page
                }
            });
            dispatch({
                type: setCountryLoading,
                payload: false
            });
        } else {
            dispatch({
                type: setCountryLoading,
                payload: false
            });
        }
    } catch (error) {
        return null
    } finally {
        dispatch({
            type: setCountryLoading,
            payload: false
        });
    }
}

async function getMobileServiceTypeOptions(dispatch, vendorId, circuitTypeId, employeeId, pageIndex, searchString) {
    const pageSize = 15;

    dispatch({
        type: setMobServiceTypeLoading
        , payload: true
    })

    let url = `external/orderRequest/getAllMobileServiceTypesOptions/${vendorId}/${circuitTypeId}/${employeeId}/${pageIndex}/${pageSize}`
    if (searchString) {
        url += `/${encodeURIComponent(searchString)}`;
    }
    var res = await httpGet(url);

    try {
        if (res != null) {
            dispatch({
                type: setEquipmentOptions,
                mobileServiceTypeOptions: res,
                mobServiceTypePage: pageIndex
            });

            dispatch({
                type: setMobServiceTypeLoading
                , payload: false
            })
        }
    }
    catch (e) {
        dispatch({
            type: setEquipmentOptions,
            mobileServiceTypeOptions: [],
        });

        return [];
    }
    finally {
        dispatch({
            type: setMobServiceTypeLoading
            , payload: false
        })
    }
}

async function getBusinessCases(dispatch) {
    var res = await httpPost('external/replaceDevice/getBusinessCases');

    if (res != null) {
        dispatch({ type: setBusinessCaseOptions, data: res });
    } else {
        dispatch({ type: setBusinessCaseOptions, data: { ...defaultState.businessCaseOptions } });
    }
}

async function getServiceTypeDetails(dispatch, typeId) {

    var res = await httpGet('external/orderRequest/getMobileServiceTypeDetails/' + typeId);

    if (res != null && res.length > 0) {
        dispatch({ type: setServiceTypeDetails, data: res[0] });
        dispatch(actions.change('wirelessReplaceDeviceFormA.mobileServiceModel', res));
    } else {
        dispatch({ type: setServiceTypeDetails, data: serviceTypeDetailConst });
        dispatch(actions.change('wirelessReplaceDeviceFormA.mobileServiceModel', []));
    }

}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setUserLocation:
            return {
                ...state,
                userLocation: action.data
            };
        case setCountryOptions:
            const { country, countryPage } = action.payload
            return {
                ...state,
                countryOptions: countryPage === 1
                    ? country : [...state.countryOptions, ...country]
                , countryPage: countryPage
                , hasMoreCountry: country.length > 0
            };
        case setCountryLoading:
            return {
                ...state,
                isCountryLoading: action.payload
            };
        case setAddressOptions:
            const { address, addressPage } = action.payload;
            return {
                ...state,
                addressOptions: addressPage === 1
                    ? address : [...state.addressOptions, ...address]
                , addressPage: addressPage
                , hasMoreAddress: address.length > 0
            };
        case setAddressLoading:
            return {
                ...state,
                isAddressLoading: action.payload
            };
        case setEquipmentOptions:
            const { mobileServiceTypeOptions, mobServiceTypePage } = action;
            const mobServiceType = Array.isArray(mobileServiceTypeOptions) ? mobileServiceTypeOptions : [];

            return {
                ...state,
                equipmentOptions: mobServiceTypePage === 1
                    ? mobServiceType
                    : [...state.equipmentOptions, ...mobServiceType]
                , mobServiceTypePage: mobServiceTypePage
                , hasMoreMobServiceType: mobServiceType.length > 0
            };
        case setMobServiceTypeLoading:
            return {
                ...state
                , isMobServiceTypeLoading: action.payload
            }
        case setBusinessCaseOptions:
            return {
                ...state
                , businessCaseOptions: action.data
            };
        case setDeviceAccessories:
            return {
                ...state,
                deviceAccessories: action.data
            };
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setServiceTypeDetails:
            return {
                ...state,
                serviceTypeDetail: action.data
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };
        case setFormLoading:
            return {
                ...state
                , isFormLoading: action.data
            };
        case setResetLoading:
            return {
                ...state
                , isResetLoading: action.data
            }
        default: return state;
    }
}